import axios from "axios";

const API = axios.create({
  baseURL: "https://us-central1-fep-iitk.cloudfunctions.net/api"
});

export const signupUser = (data) => API.post("/signup", data);
export const verifyOtp = (data) => API.post("/verify-otp", data);
export const resendOtp = (data) => API.post("/resend-otp", data);
export const notifyApplicationSubmitted = (token, data) =>
  API.post("/notify-application", data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
export const requestDeleteCode = (token) =>
  API.post(
    "/request-delete-code",
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
export const deleteAccount = (token, code) =>
  API.post(
    "/delete-account",
    { code },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

export const requestResetOtp = (data) => API.post("/request-reset-otp", data);
export const verifyResetOtp = (data) => API.post("/verify-reset-otp", data);
export const executeResetPassword = (data) => API.post("/execute-reset-password", data);

